<template>
	<div>
       <a-modal v-model="visible" 
	    title="批量离场" cancelText="取消" okText="确定" @ok="savefn">
			 <a-calendar  :fullscreen="false" @select="setdateinfo" />
	   </a-modal>
	</div>
</template>
<script>

import moment from "moment"
import {changekaoqindate} from "@/api/paylog.js"
import {message} from "ant-design-vue"
moment.locale("zh-cn")
export default {
	data(){
		return {
			visible:false,
			value:moment().format("YYYY-MM-DD")
		}
	},
	methods:{
		savefn(){
			this.onOk(this.value).then(ret=>{
				this.visible=false
			})
		},
		setdateinfo(val){
			this.value = val.format("YYYY-MM-DD")
		},
		showModal(){
			this.visible = true
		}
	},
	props:[
		'onOk',
	]
}
</script>

